import React, { useState } from "react";
import { useEditor } from "prosekit/react";
import {
  AutocompleteEmpty,
  AutocompleteItem,
  AutocompleteList,
  AutocompletePopover,
} from "prosekit/react/autocomplete";

import type { EditorExtension } from "./extension";
import { stringify } from "query-string";
import { useQuery } from "react-query";
import { Tag } from "components/shared/form/fields/TagSelect";

export default function TagSelect() {
  const editor = useEditor<EditorExtension>();
  const [q, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  const handleMemberInsert = (id: string, name: string) => {
    editor.commands.insertMention({
      id: `#[${id}:${name}]`,
      value: `#${name}`,
      kind: "tag",
    });
    editor.commands.insertText({ text: " " });
  };

  const { isLoading, data: tags } = useQuery<Tag[]>(
    `/tags/find?${stringify({ q })}`,
    {
      enabled: open,
    },
  );

  return (
    <AutocompletePopover
      regex={/#\w+$/}
      onQueryChange={setQuery}
      onOpenChange={setOpen}
      className="relative block max-h-[25rem] min-w-[15rem] select-none overflow-auto whitespace-nowrap p-1 z-10 box-border rounded-lg border border-gray-200 bg-white shadow-lg [&:not([data-state])]:hidden"
    >
      <AutocompleteList filter={null}>
        <AutocompleteEmpty className="relative flex items-center justify-between min-w-[8rem] scroll-my-1 rounded px-3 py-1.5 box-border cursor-default select-none whitespace-nowrap outline-none data-[focused]:bg-gray-100">
          {isLoading
            ? I18n.t("js.composer.editor.buttons.loading")
            : I18n.t("js.composer.editor.buttons.no_result")}
        </AutocompleteEmpty>

        {tags?.map((tag) => (
          <AutocompleteItem
            key={tag.id}
            className="relative flex items-center justify-between min-w-[8rem] scroll-my-1 rounded px-2 py-1.5 box-border cursor-default select-none whitespace-nowrap outline-none data-[focused]:bg-gray-100"
            onSelect={() => handleMemberInsert(tag.id, tag.name)}
          >
            <span className={`grow ${isLoading ? "opacity-50" : undefined}`}>
              {tag.name}
            </span>
          </AutocompleteItem>
        ))}
      </AutocompleteList>
    </AutocompletePopover>
  );
}
